import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CashbackComponent } from './cashback/cashback.component';
import { TransactionPageComponent } from './transaction-page/transaction-page.component';
import { SwinkpayProcessingComponent } from './swinkpay-processing/swinkpay-processing.component';
import { SwinkpaySuccessComponent } from './swinkpay-success/swinkpay-success.component';
import { SwinkpayFailedComponent } from './swinkpay-failed/swinkpay-failed.component';
import { PaymentFailedComponent } from './payment-failed/payment-failed.component';
import { QsFormComponent } from './qs-form/qs-form.component';
import { PaymentPendingComponent } from './payment-pending/payment-pending.component';
import { RewardFormsComponent } from './reward-forms/reward-forms.component';
import { RazorpayCheckoutComponent } from './razorpay-checkout/razorpay-checkout.component';
import { RedirectPageComponent } from './redirect-page/redirect-page.component';
import { TcComponent } from './tc/tc.component';
import { CampaignSurveyComponent } from './campaign-survey/campaign-survey.component';

const routes: Routes = [
  { path: '', redirectTo: 'transaction', pathMatch: 'full' },
  {
    path: '',
    redirectTo: 'transaction',
    pathMatch: 'full',
  },
  {
    path: 'transaction',
    component: TransactionPageComponent,
  },
  {
    path: 'processing',
    component: SwinkpayProcessingComponent,
  },
  {
    path: 'success',
    component: SwinkpaySuccessComponent,
  },
  {
    path: 'qs-form',
    component: QsFormComponent,
  },
  {
    path: 'redirect',
    component: RedirectPageComponent,
  },
  {
    path: 'rewards-form',
    component: RewardFormsComponent,
  },

  {
    path: 'failure',
    component: SwinkpayFailedComponent,
  },
  {
    path: 'payment-failure',
    component: PaymentFailedComponent,
  },
  {
    path: 'payment-pending',
    component: PaymentPendingComponent,
  },
  {
    path: 'razorpay-checkout',
    component: RazorpayCheckoutComponent,
  },
  {
    path: 'tc',
    component: TcComponent,
  },
  {
    path: 'campaign-survey',
    component: CampaignSurveyComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
